import { typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const TooltipWrapper = styled.div<{ $isRead?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  margin-bottom: 12px;
  cursor: pointer;
  &:hover {
    background-color: var(--surface-hover);
  }
  padding: 0;

  ${({ $isRead }) =>
    $isRead &&
    css`
      svg > path {
        fill: var(--surface-default);
        stroke: var(--border-soft);
      }

      svg g path {
        fill: var(--icon-soft);
      }
    `}
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TooltipTitleLabel = styled.span`
  ${typographyV2.titleSm};
`;

export const CategoryLabel = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
